import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Menu, Languages, LogOut } from 'lucide-react'
import { Button } from '@/components/ui/button'
import {
  Sheet,
  SheetContent,
  SheetTrigger,
} from '@/components/ui/sheet'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'

interface StaffBurgerMenuProps {
  onLogout: () => void
  isLoggingOut?: boolean
}

export function StaffBurgerMenu({ onLogout, isLoggingOut = false }: StaffBurgerMenuProps) {
  const { t, i18n } = useTranslation()
  const [open, setOpen] = useState(false)
  const isRTL = i18n.dir() === 'rtl'

  const handleLanguageChange = (value: string) => {
    i18n.changeLanguage(value)
  }

  const handleLogout = () => {
    setOpen(false)
    onLogout()
  }

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <Button variant="ghost" size="icon" className="shrink-0 md:hidden">
          <Menu className="h-5 w-5" />
          <span className="sr-only">Open menu</span>
        </Button>
      </SheetTrigger>
      <SheetContent side={isRTL ? 'right' : 'left'} className="w-[280px] sm:w-[320px]">
        <div className="flex flex-col gap-4 py-6 flex-1 min-h-0">
          {/* Language Selector */}
          <div className="space-y-2">
            <div className="flex items-center gap-2 px-3 text-sm font-medium">
              <Languages className="w-4 h-4" />
              <span>{t('user.language')}</span>
            </div>
            <Select value={i18n.language} onValueChange={handleLanguageChange}>
              <SelectTrigger className="w-full">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="fr">Français</SelectItem>
                <SelectItem value="ar">العربية</SelectItem>
              </SelectContent>
            </Select>
          </div>

          {/* Divider */}
          <div className="border-t" />

          {/* Logout Button */}
          <Button
            variant="ghost"
            className="justify-start gap-3 px-3"
            onClick={handleLogout}
            disabled={isLoggingOut}
          >
            <LogOut className="w-5 h-5" />
            {t('auth.logout')}
          </Button>
        </div>
      </SheetContent>
    </Sheet>
  )
}

